import React, { useState } from 'react'
import EditMenu from '../editMenu'
import { withTheme } from 'theming'
import AddSection from '../addSection'
import CustomImage from '../../customImage/customImage'
import useTemplateHook from '../templateHook'

const PromotionalLead = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id, config } = componentData
  const { customNavigate, getTemplateImage } = useTemplateHook()

  const [hoverState, setHoverState] = useState('')
  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  return (
    <div
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
      className={`${
        isEdit && hoverState && 'component-hover-class'
      } w-full h-[153px] md:h-[60vh] bg-cover relative cursor-pointer`}
      onClick={() => handleRedirect(data?.cta_button?.link)}
    >
      <CustomImage
        imageUrl={getTemplateImage(data?.image_s3key)}
        imgClass="absolute w-full h-full"
        loaderClass="w-full h-full absolute"
        loaderStyle={{
          background: '#5A5A5A50',
        }}
        imgAlt={'category'}
      />
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onEdit={handleModal}
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onCopy={() => onCopy(id)}
        />
      )}
      <div className={`flex h-full flex-col ${config[data?.position]} md:p-6 p-[6px] z-10`}>
        <h1
          style={{ color: theme.c2 }}
          className={`text-[18px] md:text-3xl lg:text-4xl 2xl:text-5xl font-bold mb-3 drop-shadow-md z-10`}
        >
          {data?.heading}
        </h1>
        <p
          style={{ color: theme.c5 }}
          className={`text-[10px] sm:text-base w-full md:w-1/2 xl:w-[32%] font-normal mb-6 z-10`}
        >
          {data?.description}
        </p>
        {data?.cta_button?.enabled && (
          <div className="w-2/3 md:w-1/2 xl:w-[32%] flex justify-between items-center z-10">
            {data?.input_placeholder && (
              <input
                type="text"
                placeholder={data?.input_placeholder}
                className="border-0 py-[0.25rem] px-[0.25rem] md:p-2 md:px-3 w-[65%] text-[10px] sm:text-base rounded shadow-md shadow-gray-500 bg-white"
                disabled={isEdit}
              />
            )}

            <button
              style={{ background: theme.c5, color: theme.c7 }}
              className={` border-0 py-[0.25rem] md:p-2 w-[32%] rounded shadow-md shadow-gray-700 text-[10px] sm:text-base`}
              onClick={() => handleRedirect(data?.cta_button?.link)}
              disabled={isEdit}
            >
              {data?.cta_button?.text}
            </button>
          </div>
        )}

        {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
      </div>
    </div>
  )
}

export default withTheme(PromotionalLead)
